module.exports = __webpack_public_path__ + "img/kmfm.5a654df6.png";